import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'text-data-primeira-cnh',
  templateUrl: './text-data-primeira-cnh.component.html',
  styleUrls: ['./text-data-primeira-cnh.component.scss']
})
export class TextDataPrimeiraCnhComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
